import echarts from 'echarts/lib/echarts'

// Dark theme for ECharts
const darkTheme = {
  color: ['#667eea', '#764ba2', '#f093fb', '#fccb90', '#48c6ef', '#6f86d6', '#11998e', '#38ef7d'],
  backgroundColor: 'transparent',
  textStyle: {
    color: '#b4b7bd',
  },
  title: {
    textStyle: {
      color: '#d0d2d6',
    },
    subtextStyle: {
      color: '#676d7d',
    },
  },
  legend: {
    textStyle: {
      color: '#b4b7bd',
    },
  },
  tooltip: {
    backgroundColor: '#283046',
    borderColor: '#3b4253',
    textStyle: {
      color: '#b4b7bd',
    },
  },
  categoryAxis: {
    axisLine: {
      lineStyle: {
        color: '#3b4253',
      },
    },
    axisTick: {
      lineStyle: {
        color: '#3b4253',
      },
    },
    axisLabel: {
      color: '#b4b7bd',
    },
    splitLine: {
      lineStyle: {
        color: '#3b4253',
      },
    },
  },
  valueAxis: {
    axisLine: {
      lineStyle: {
        color: '#3b4253',
      },
    },
    axisTick: {
      lineStyle: {
        color: '#3b4253',
      },
    },
    axisLabel: {
      color: '#b4b7bd',
    },
    splitLine: {
      lineStyle: {
        color: '#3b4253',
      },
    },
  },
}

// Register the dark theme
echarts.registerTheme('dark', darkTheme)

export default darkTheme
